<template>
    <div>
        <el-form ref="searchForm" :inline="true" :model="searchForm">
            <el-form-item label="代理商名称：">
                <el-input v-model.trim="searchForm.nickName" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getAgentListHandle">搜索</el-button>
                <el-button type="success" @click="showAddNewAgentHandle">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border >
            <el-table-column type="index" label="序号" ></el-table-column>
            <el-table-column prop="nickName" label="代理商名称"></el-table-column>
            <el-table-column prop="smsStateName" label="短信状态"></el-table-column>
            <el-table-column prop="maxSmdRed" label="短信收发数"></el-table-column>
            <el-table-column prop="maxSmsSend" label="短信发送数"></el-table-column>
            <el-table-column prop="accountStateName" label="预存账户状态"></el-table-column>
            <el-table-column prop="balanceBig" label="预存剩余金额"></el-table-column>
            <el-table-column prop="voicePrice" label="语音短信 分/分钟"></el-table-column>
            <el-table-column label="操作" width="250">
                <template slot-scope="scope">                    
                    <el-button type="text" size="small" @click="showEditAgentInfo(scope.row)">短信编辑</el-button>
                    <el-button type="text" size="small" @click="showEditAgentInfo1(scope.row)">账户编辑</el-button>
                    <el-button type="text" size="small" @click="showEditAgentInfo2(scope.row)">语音短信编辑</el-button>
                    <!-- <el-button type="text" size="small" v-if="scope.row.smsState == 1" @click="updateSMSPermissions(scope.row.id, 2)">取消授权</el-button>
                    <el-button type="text" size="small" v-else-if="scope.row.smsState == 2"  @click="updateSMSPermissions(scope.row.id, 1)">短信授权</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :title="title" :visible.sync="addNewAgentVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="newAgentForm" :model="newAgentForm"  label-width="120px">
                <el-form-item label="代理商名称：" prop="nickName">
                    <el-input v-model.trim="newAgentForm.nickName" :disabled="accountDisabled" clearable></el-input>
                </el-form-item>
                <el-form-item label="短信授权状态："> 
                <el-select v-model="newAgentForm.smsState" clearable> 
                <el-option value="1" label="已授权无限制"></el-option>
                <el-option value="2" label="禁止收发短信"></el-option>
                <el-option value="3" label="已授权有数量限制"></el-option>
                </el-select>
            </el-form-item>
                <el-form-item label="最大发送量：" prop="phone">
                    <el-input v-model.trim="newAgentForm.maxSmsSend" clearable></el-input>
                </el-form-item>
                <el-form-item label="最大接收量：" prop="phone">
                    <el-input v-model.trim="newAgentForm.maxSmdRed" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEditNewAgentHandle">确 定</el-button>
            </div>   
        </el-dialog> 
         <el-dialog :title="title" :visible.sync="addNewAgentVisibale1" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="newAgentForm" :model="newAgentForm"  label-width="120px">
                <el-form-item label="代理商名称：" prop="nickName">
                    <el-input v-model.trim="newAgentForm.nickName" :disabled="accountDisabled" clearable></el-input>
                </el-form-item>
                <el-form-item label="账户余额：" prop="phone">
                    <el-input v-model.trim="newAgentForm.balanceBig" :disabled="accountDisabled"   clearable></el-input>
                </el-form-item>
                <el-form-item label="账户授权状态："> 
                <el-select v-model="newAgentForm.accountState" clearable>
                <el-option value="0" label="暂无开户"></el-option>
                <el-option value="1" label="正常-预存不可为负"></el-option>
                <el-option value="2" label="正常-预存可以为负"></el-option>
                <el-option value="3" label="冻结-限制任何交易"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="变动金额：" prop="amount">
                    <el-input v-model.trim="newAgentForm.amount"   clearable></el-input>
                </el-form-item>
                 <el-form-item label="变动备注：" prop="remark">
                    <el-input v-model.trim="newAgentForm.remark"  clearable></el-input>
                </el-form-item>
                 <el-form-item label="变动类型：" prop="type">
                    <el-radio-group v-model="newAgentForm.type">
                        <el-radio label="0">扣减</el-radio>
                        <el-radio label="1">增加（不记入历史总额）</el-radio>
                        <el-radio label="2">充值（记入历史总额）</el-radio>
                    </el-radio-group>
            </el-form-item>
            </el-form>
            
           
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEditNewAgentHandle1">确 定</el-button>
            </div>   
        </el-dialog>
         <el-dialog :title="title" :visible.sync="addNewAgentVisibale2" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="newAgentForm" :model="newAgentForm"  label-width="120px">
                <el-form-item label="代理商名称：" prop="nickName">
                    <el-input v-model.trim="newAgentForm.nickName" :disabled="accountDisabled" clearable></el-input>
                </el-form-item>
                <el-form-item label="分/分钟：" prop="phone">
                    <el-input v-model.trim="newAgentForm.voicePrice" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEditNewAgentHandle2">确 定</el-button>
            </div>   
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="confirmVisible"
            width="30%">
            <span>确定要重置密码吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmVisible = false">取 消</el-button>
                <el-button type="primary" @click="resetPassword">确 定</el-button>
            </span>
        </el-dialog>        
    </div>
</template>

<script>
import {addNewAgent, getAgentList, updateAgentInfo1, updateAgentInfo2, doResetPassword, doUpdateSMSPermissions, deleteCustomer,updateAgentInfo3} from '@/api/customers.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                nickName: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                 
            },            
            addNewAgentVisibale: false,
            addNewAgentVisibale1:false,
            addNewAgentVisibale2:false,
            title: '新增代理商',
            accountDisabled: false,
            newAgentForm: {
                type:'',
                remark:'',
                amount:'',
                nickName: '',

                maxSmsSend: '',
                maxSmdRed: '',
                smsState: 1,
                accountState:'',
                balanceBig:0,
                voicePrice:''
            },
            addFlag: true,
            currentId: '',
            newAgentFormRules: {
                nickName: [{required: true, message: '请输入代理商名称', trigger: 'blur'}],
                accountName: [{required: true, validator: this.checkAccount, trigger: 'blur'}],
                pwd: [{required: true, validator: this.checkPassword, trigger: 'blur'}],
                phone: [{required: true, validator: this.checkPhone, trigger: 'blur'}]
            },
            confirmVisible :false,
            id_forResetPassword:'',
        }
    },
    methods: {
        cancel(){
            
            for(let key in this.newAgentForm){                
                this.newAgentForm[key] = null;
            }
            this.addNewAgentVisibale2 = false;

            this.addNewAgentVisibale = false;
            this.addNewAgentVisibale1 = false;
            this.$refs.newAgentForm.resetFields(); 
        },
        getAgentListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getAgentList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showAddNewAgentHandle(){
            this.title = '新增代理商';

            for(let key in this.newAgentForm){                
                this.newAgentForm[key] = null;
            }

            this.addNewAgentVisibale = true;
            this.accountDisabled = false;
            this.addFlag = true;
        },
        showEditAgentInfo(row){
            if(row){
                this.title = '短信授权配置';
                this.addNewAgentVisibale = true;
                this.accountDisabled = true;
                this.addFlag = false;
                this.currentId = row.id;
                for(var key in this.newAgentForm){                
                    if(typeof(row[key]) == 'string'){
                        this.newAgentForm[key] = (row[key]).replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
                    }else{
                        this.newAgentForm[key] = row[key];
                    }                
                }
            }
        },
         showEditAgentInfo1(row){
            if(row){
                this.title = '账户授权配置';
                this.addNewAgentVisibale1 = true;
                this.accountDisabled = true;
                this.addFlag = false;
                this.currentId = row.id;
                for(var key in this.newAgentForm){                
                    if(typeof(row[key]) == 'string'){
                        this.newAgentForm[key] = (row[key]).replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
                    }else{
                        this.newAgentForm[key] = row[key];
                    }                
                }
            }
        },
         showEditAgentInfo2(row){
            if(row){
                this.title = '账户授权配置';
                this.addNewAgentVisibale2 = true;
                this.accountDisabled = true;
                this.addFlag = false;
                this.currentId = row.id;
                for(var key in this.newAgentForm){                
                    if(typeof(row[key]) == 'string'){
                        this.newAgentForm[key] = (row[key]).replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
                    }else{
                        this.newAgentForm[key] = row[key];
                    }                
                }
            }
        },
        addOrEditNewAgentHandle(){
            this.$refs.newAgentForm.validate(valid => {
                if(valid){
                    var data = this.newAgentForm;     
                        data.id = this.currentId;
                        updateAgentInfo1(data).then(res => {
                            if(res.data.code == 200){
                                callback(res)
                                this.addNewAgentVisibale1=false;
                                this.$message.success(res.data.message);
                                this.getAgentListHandle();
                            }else{
                                this.$message.error(res.data.message);
                            }
                        })                        
                    
                }
                 this.addNewAgentVisibale1=false;
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getAgentListHandle();
                        _this.addNewAgentVisibale1 = false;
                         this.addNewAgentVisibale1=false;
                        
                    }else{
                        _this.$message.error(res.data.message)
                    }                     
                }
            })
        },     
        addOrEditNewAgentHandle1(){
            this.$refs.newAgentForm.validate(valid => {
                if(valid){
                    var data = this.newAgentForm;     
                        data.id = this.currentId;
                        updateAgentInfo2(data).then(res => {
                            if(res.data.code == 200){
                                this.getAgentListHandle();
                                this.addNewAgentVisibale1=false;
                                callback(res)
                                this.$message.success(res.data.message);
                                
                            }else{
                                this.$message.error(res.data.message);
                            }
                        })                        
                    
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getAgentListHandle();
                        _this.addNewAgentVisibale = false;
                        
                    }else{
                        _this.$message.error(res.data.message)
                    }                     
                }
            })
        },   
         addOrEditNewAgentHandle2(){
            this.$refs.newAgentForm.validate(valid => {
                if(valid){
                    var data = this.newAgentForm;     
                        data.id = this.currentId;
                        updateAgentInfo3(data).then(res => {
                            if(res.data.code == 200){
                                callback(res)
                                this.$message.success(res.data.message);
                                this.getAgentListHandle();
                            }else{
                                this.$message.error(res.data.message);
                            }
                        })                        
                    
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getAgentListHandle();
                        _this.addNewAgentVisibale = false;
                        
                    }else{
                        _this.$message.error(res.data.message)
                    }                     
                }
            })
        },   
        showResetPassworDialog(row){
            this.confirmVisible = true;
            this.id_forResetPassword = row.id;
        },
        deleteHandle(row) {
            let data = {
                id: row.agentId
            }
            this.$confirm('确定删除吗？','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteCustomer(data).then(res => {
                    if(res.data.code == 200) {
                        this.$message({
                            type: 'success',
                            message: res.data.message
                        });
                    }
                    else {
                        this.$message.error(res.data.message)
                    }
                })
            })
        },

        resetPassword(){
            doResetPassword({id:this.id_forResetPassword}).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.confirmVisible = false;
                    this.getAgentListHandle();
                }else{
                    this.$message.error(res.data.message);
                }
            })

        },

        updateSMSPermissions(id, state){
            let data = {
                id: id,
                smsState: state,
            }

            doUpdateSMSPermissions(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getAgentListHandle();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAgentListHandle();
        }  
    },
    created () {
        this.getAgentListHandle()
    }  
}
</script>

<style lang="scss" scoped>

</style>

